'use strict'

module.exports = require('./utils/interpolate').interpolateArray(require('./hex/viridis.json'))



//////////////////
// WEBPACK FOOTER
// ./~/scale-color-perceptual/viridis.js
// module id = 854
// module chunks = 0